<template>
  <div id="top"></div>
  <header data-elementor-type="header" data-elementor-id="2238"
    class="elementor elementor-2238 elementor-location-header" data-elementor-post-type="elementor_library">
    <section
      class="elementor-section elementor-top-section elementor-element elementor-element-256c209 elementor-section-content-middle elementor-section-height-min-height elementor-hidden-tablet elementor-hidden-mobile elementor-section-boxed elementor-section-height-default elementor-section-items-middle elementor-invisible"
      data-id="256c209" data-element_type="section" data-e-type="section"
      data-settings="{&quot;sticky&quot;:&quot;top&quot;,&quot;sticky_on&quot;:[&quot;desktop&quot;],&quot;animation&quot;:&quot;fadeIn&quot;,&quot;background_background&quot;:&quot;classic&quot;,&quot;sticky_offset&quot;:0,&quot;sticky_effects_offset&quot;:0,&quot;sticky_anchor_link_offset&quot;:0}">
      <div class="elementor-container elementor-column-gap-no">
        <div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-2ae7f28"
          data-id="2ae7f28" data-element_type="column" data-e-type="column">
          <div class="elementor-widget-wrap elementor-element-populated">
            <div
              class="elementor-element elementor-element-f9216cd elementor-widget elementor-widget-theme-site-logo elementor-widget-image"
              data-id="f9216cd" data-element_type="widget" data-e-type="widget"
              data-widget_type="theme-site-logo.default">
              <div class="elementor-widget-container">
                <a href="/">
                  <img width="195" height="36" src="assets/logo.png"
                    class="attachment-full size-full wp-image-2484" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-22ad825"
          data-id="22ad825" data-element_type="column" data-e-type="column">
          <div class="elementor-widget-wrap elementor-element-populated">
            <div
              class="vamtam-has-theme-widget-styles elementor-element elementor-element-842f9b4 elementor-nav-menu__align-center elementor-nav-menu--dropdown-tablet elementor-nav-menu__text-align-aside elementor-nav-menu--toggle elementor-nav-menu--burger vamtam-has-mobile-disable-scroll elementor-widget elementor-widget-nav-menu"
              data-id="842f9b4" data-element_type="widget" data-e-type="widget"
              data-settings="{&quot;submenu_icon&quot;:{&quot;value&quot;:&quot;&lt;i class=\&quot;\&quot; aria-hidden=\&quot;true\&quot;&gt;&lt;\/i&gt;&quot;,&quot;library&quot;:&quot;&quot;},&quot;layout&quot;:&quot;horizontal&quot;,&quot;toggle&quot;:&quot;burger&quot;}"
              data-widget_type="nav-menu.default">
              <div class="elementor-widget-container">
                <nav aria-label="Menu"
                  class="elementor-nav-menu--main elementor-nav-menu__container elementor-nav-menu--layout-horizontal e--pointer-theme-underline">
                  <ul id="menu-1-842f9b4" class="elementor-nav-menu">
                    <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2242">
                      <a href="/" class="elementor-item">Home</a>
                    </li>
                    <li class="mega-menu-about-big-construction- menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item current-menu-ancestor current-menu-parent menu-item-has-children menu-item-12976">
                      <a href="#" aria-current="page" class="elementor-item">About Us</a>
                      <ul class="sub-menu elementor-nav-menu--dropdown">
                        <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-1905 current_page_item menu-item-3265">
                          <a href="/about-us" aria-current="page" class="elementor-sub-item">
                            Who We Are
                          </a>
                        </li>
                        <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-1905 current_page_item menu-item-3265">
                          <a href="/vision-mission" aria-current="page" class="elementor-sub-item">
                            Vision and Mission
                          </a>
                        </li>
                        <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-3266">
                          <a class="elementor-sub-item" target="_blank" :href="generalStore.downloadUrl" :download="generalStore.downloadFileName">
                            Download Company Profile
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li class="mega-menu-services-big-construction- menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item current-menu-ancestor current-menu-parent menu-item-has-children menu-item-12976">
                      <a href="#" aria-current="page" class="elementor-item">Services</a>
                      <ul class="sub-menu elementor-nav-menu--dropdown">
                        <li v-for="cat in generalStore.categories" :key="cat.id" class="menu-item menu-item-has-children menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-1905 current_page_item menu-item-3265">
                          <a :href="`/our-services/category/` + cat.slug" aria-current="page" class="elementor-sub-item">
                            {{ cat.name }}
                          </a>
                          <ul class="sub-menu elementor-nav-menu--dropdown">
                            <li v-for="subCat in cat.subCategories" :key="subCat.id" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-1905 current_page_item menu-item-3265">
                              <a :href="`/our-services/details/` + cat.slug + `/` + subCat.slug" aria-current="page" class="elementor-sub-item">
                                {{ subCat.name }}
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li class="mega-menu-services-big-construction- menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item current-menu-ancestor current-menu-parent menu-item-has-children menu-item-12976">
                      <a href="#" aria-current="page" class="elementor-item">Projects</a>
                      <ul class="sub-menu elementor-nav-menu--dropdown">
                        <li class="menu-item menu-item-has-children menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-1905 current_page_item menu-item-3265">
                          <a href="/projects" aria-current="page" class="elementor-sub-item">
                            Ongoing Projects
                          </a>
                        </li>
                        <li class="menu-item menu-item-has-children menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-1905 current_page_item menu-item-3265">
                          <a href="/project-experiences" aria-current="page" class="elementor-sub-item">
                            Our Experiences
                          </a>
                        </li>
                      </ul>
                    </li>
                    <!-- <li
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-12979">
                      <a href="/projects"
                        class="elementor-item">Projects</a>
                    </li>
                    <li
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-12979">
                      <a href="/project-experiences"
                        class="elementor-item">Experiences</a>
                    </li> -->
                    <li
                      class="menu-item menu-item-type-post_type menu-item-object-page menu-item-12978">
                      <a href="/news" class="elementor-item">News</a>
                    </li>
                    <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2248">
                      <a href="/careers" class="elementor-item">Careers</a>
                    </li>
                  </ul>
                </nav>
                <div class="elementor-menu-toggle" role="button" tabindex="0" aria-label="Menu Toggle" aria-expanded="false">
                  <i aria-hidden="true" role="presentation" class="elementor-menu-toggle__icon--open eicon-menu-bar"></i>
                  <i aria-hidden="true" role="presentation" class="elementor-menu-toggle__icon--close eicon-close"></i>
                </div>
                <nav class="elementor-nav-menu--dropdown elementor-nav-menu__container" aria-hidden="true">
                  <ul id="menu-2-842f9b4" class="elementor-nav-menu">
                    <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2242">
                      <a href="/" class="elementor-item" tabindex="-1">Home</a>
                    </li>
                    <li class="mega-menu-about-big-construction- menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item current-menu-ancestor current-menu-parent menu-item-has-children menu-item-2242">
                      <a href="#" aria-current="page" class="elementor-item" tabindex="-1">About Us</a>
                      <ul class="sub-menu elementor-nav-menu--dropdown">
                        <li
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-1905 current_page_item menu-item-3265">
                          <a href="/about-us" aria-current="page"
                            class="elementor-sub-item" tabindex="-1">Who We Are</a>
                        </li>
                        <li
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-1905 current_page_item menu-item-3265">
                          <a href="/vision-mission" aria-current="page"
                            class="elementor-sub-item" tabindex="-1">Vision and Mission</a>
                        </li>
                        <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-3266">
                          <a target="_blank" :href="generalStore.downloadUrl" :download="generalStore.downloadFileName" class="elementor-sub-item"
                            tabindex="-1">Download Company Profile</a>
                        </li>
                      </ul>
                    </li>
                    <li class="mega-menu-services-big-construction- menu-item menu-item-type-post_type menu-item-object-page menu-item-12979">
                      <a href="#" class="elementor-item" tabindex="-1">Services</a>
                      <ul class="sub-menu elementor-nav-menu--dropdown">
                        <li v-for="cat in generalStore.categories" :key="cat.id" class="menu-item menu-item-has-children menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-1905 current_page_item menu-item-3265">
                          <a :href="`/our-services/category/` + cat.slug" aria-current="page" class="elementor-sub-item">
                            {{ cat.name }}
                          </a>
                          <ul class="sub-menu elementor-nav-menu--dropdown">
                            <li v-for="subCat in cat.subCategories" :key="subCat.id" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-1905 current_page_item menu-item-3265">
                              <a :href="`/our-services/details/` + cat.slug + `/` + subCat.slug" aria-current="page" class="elementor-sub-item">
                                {{ subCat.name }}
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li class="mega-menu-services-big-construction- menu-item menu-item-type-post_type menu-item-object-page menu-item-12979">
                      <a href="#" class="elementor-item" tabindex="-1">Projects</a>
                      <ul class="sub-menu elementor-nav-menu--dropdown">
                        <li class="menu-item menu-item-has-children menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-1905 current_page_item menu-item-3265">
                          <a href="/projects" aria-current="page" class="elementor-sub-item">
                            Ongoing Projects
                          </a>
                        </li>
                        <li class="menu-item menu-item-has-children menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-1905 current_page_item menu-item-3265">
                          <a href="/project-experiences" aria-current="page" class="elementor-sub-item">
                            Our Experiences
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2248">
                      <a href="/news" class="elementor-item" tabindex="-1">News</a>
                    </li>
                    <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2247">
                      <a href="/news" class="elementor-item" tabindex="-1">Careers</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-ffce91d"
          data-id="ffce91d" data-element_type="column" data-e-type="column">
          <div class="elementor-widget-wrap elementor-element-populated">
            <div
              class="elementor-element elementor-element-65af76d elementor-widget__width-auto elementor-view-default elementor-widget elementor-widget-icon"
              data-id="65af76d" data-element_type="widget" data-e-type="widget" data-widget_type="icon.default">
              <div class="elementor-widget-container">
                <div class="elementor-icon-wrapper">
                  <a class="elementor-icon"
                    href="#elementor-action%3Aaction%3Dpopup%3Aopen%26settings%3DeyJpZCI6IjMyODEiLCJ0b2dnbGUiOmZhbHNlLCJhbGlnbl93aXRoX3BhcmVudCI6IiJ9">
                    <i aria-hidden="true" class="vamtamtheme- vamtam-theme-search"></i>
                  </a>
                </div>
              </div>
            </div>
            <div
              class="vamtam-has-theme-widget-styles elementor-element elementor-element-d45b76a elementor-align-right elementor-widget__width-auto vamtam-has-underline-anim elementor-widget elementor-widget-button"
              data-id="d45b76a" data-element_type="widget" data-e-type="widget" data-widget_type="button.default">
              <div class="elementor-widget-container">
                <div class="elementor-button-wrapper">
                  <a class="elementor-button elementor-button-link elementor-size-sm"
                    href="#elementor-action%3Aaction%3Dpopup%3Aopen%26settings%3DeyJpZCI6IjMyNzMiLCJ0b2dnbGUiOmZhbHNlLCJhbGlnbl93aXRoX3BhcmVudCI6IiJ9">
                    <span class="elementor-button-content-wrapper">
                      <span class="elementor-button-icon">
                        <i aria-hidden="true" class="vamtamtheme- vamtam-theme-contact"></i>
                      </span>
                      <span class="elementor-button-text">Get in touch</span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="elementor-section elementor-top-section elementor-element elementor-element-fcba482 elementor-section-content-middle elementor-section-height-min-height elementor-hidden-desktop elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
      data-id="fcba482" data-element_type="section" data-e-type="section"
      data-settings="{&quot;sticky&quot;:&quot;top&quot;,&quot;background_background&quot;:&quot;classic&quot;,&quot;sticky_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;,&quot;mobile&quot;],&quot;sticky_offset&quot;:0,&quot;sticky_effects_offset&quot;:0,&quot;sticky_anchor_link_offset&quot;:0}">
      <div class="elementor-container elementor-column-gap-no">
        <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b8e9b9e"
          data-id="b8e9b9e" data-element_type="column" data-e-type="column">
          <div class="elementor-widget-wrap elementor-element-populated">
            <div
              class="elementor-element elementor-element-8c4fa49 elementor-widget elementor-widget-theme-site-logo elementor-widget-image"
              data-id="8c4fa49" data-element_type="widget" data-e-type="widget"
              data-widget_type="theme-site-logo.default">
              <div class="elementor-widget-container">
                <a href="">
                  <img width="195" height="36"
                    src="assets/logo.png"
                    class="attachment-full size-full wp-image-2484" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-eda64ac" data-id="eda64ac" data-element_type="column" data-e-type="column">
          <div class="elementor-widget-wrap elementor-element-populated">
            <div 
              class="vamtam-has-theme-widget-styles elementor-element elementor-element-712b679 elementor-nav-menu__align-justify elementor-nav-menu--stretch elementor-widget-mobile__width-initial elementor-hidden-desktop vamtam-has-mobile-menu-max-height elementor-nav-menu--dropdown-tablet elementor-nav-menu__text-align-aside elementor-nav-menu--toggle elementor-nav-menu--burger vamtam-has-mobile-disable-scroll elementor-widget elementor-widget-nav-menu"
              data-id="712b679" data-element_type="widget" data-e-type="widget"
              data-settings="{&quot;full_width&quot;:&quot;stretch&quot;,&quot;layout&quot;:&quot;horizontal&quot;,&quot;submenu_icon&quot;:{&quot;value&quot;:&quot;&lt;i class=\&quot;fas fa-caret-down\&quot; aria-hidden=\&quot;true\&quot;&gt;&lt;\/i&gt;&quot;,&quot;library&quot;:&quot;fa-solid&quot;},&quot;toggle&quot;:&quot;burger&quot;}"
              data-widget_type="nav-menu.default">
              <div class="elementor-widget-container">
                <nav aria-label="Menu" class="elementor-nav-menu--main elementor-nav-menu__container elementor-nav-menu--layout-horizontal e--pointer-none">
                  <ul id="menu-1-712b679" class="elementor-nav-menu">
                    <li class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item current-menu-ancestor current-menu-parent menu-item-6854">
                      <a href="/" aria-current="page" class="elementor-item">Home</a>
                    </li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-6860">
                      <a href="#" class="elementor-item elementor-item-anchor">About us</a>
                      <ul class="sub-menu elementor-nav-menu--dropdown">
                        <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-6859">
                          <a href="/about-us" class="elementor-sub-item">Who we are</a>
                        </li>
                        <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-6859">
                          <a href="/vision-mission" class="elementor-sub-item">Vision and Mission</a>
                        </li>
                        <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-6861">
                          <a target="_blank" :href="generalStore.downloadUrl" :download="generalStore.downloadFileName" class="elementor-sub-item">Download Company Profile</a>
                        </li>
                        <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-6864">
                          <a href="/careers" class="elementor-sub-item">Careers</a>
                        </li>
                      </ul>
                    </li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-6866">
                      <a href="#" class="elementor-item elementor-item-anchor">Services</a>
                      <ul class="sub-menu elementor-nav-menu--dropdown">
                        <li v-for="cat in generalStore.categories" :key="cat.id" class="menu-item menu-item-has-children menu-item-type-post_type menu-item-object-page menu-item-6869">
                          <a :href="`/our-services/category/` + cat.slug" class="elementor-sub-item">
                            {{ cat.name }}
                          </a>
                          <ul class="sub-menu elementor-nav-menu--dropdown">
                            <li v-for="subCat in cat.subCategories" :key="subCat.id" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-6869">
                              <a :href="`/our-services/details/` + cat.slug + `/` + subCat.slug" class="elementor-sub-item">
                                {{ subCat.name }}
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-6866">
                      <a href="#" class="elementor-item elementor-item-anchor">Projects</a>
                      <ul class="sub-menu elementor-nav-menu--dropdown">
                        <li class="menu-item menu-item-has-children menu-item-type-post_type menu-item-object-page menu-item-6869">
                          <a href="/projects" class="elementor-sub-item">
                            Ongoing Projects
                          </a>
                        </li>
                        <li class="menu-item menu-item-has-children menu-item-type-post_type menu-item-object-page menu-item-6869">
                          <a href="/project-experiences" class="elementor-sub-item">
                            Our Experiences
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7507">
                      <a href="/news" class="elementor-item">News</a>
                    </li>
                  </ul>
                </nav>
                <div class="elementor-menu-toggle" role="button" tabindex="0" aria-label="Menu Toggle" aria-expanded="false">
                  <i aria-hidden="true" role="presentation"
                    class="elementor-menu-toggle__icon--open vamtamtheme- vamtam-theme-menu"></i>
                  <i aria-hidden="true" role="presentation"
                    class="elementor-menu-toggle__icon--close vamtamtheme- vamtam-theme-close"></i>
                </div>
                <nav class="elementor-nav-menu--dropdown elementor-nav-menu__container" aria-hidden="true">
                  <ul id="menu-2-712b679" class="elementor-nav-menu">
                    <li class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item current-menu-ancestor current-menu-parent menu-item-6854">
                      <a href="/" aria-current="page" class="elementor-item" tabindex="-1">Home</a>
                    </li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-6860">
                      <a href="#" class="elementor-item elementor-item-anchor" tabindex="-1">About us</a>
                      <ul class="sub-menu elementor-nav-menu--dropdown">
                        <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-6859">
                          <a href="/about-us" class="elementor-sub-item"
                            tabindex="-1">Who we are</a>
                        </li>
                        <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-6859">
                          <a href="/vision-mission" class="elementor-sub-item"
                            tabindex="-1">Vision and Mission</a>
                        </li>
                        <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-6861">
                          <a target="_blank" :href="generalStore.downloadUrl" :download="generalStore.downloadFileName" class="elementor-sub-item"
                            tabindex="-1">Download Company Profile</a>
                        </li>
                        <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-6864">
                          <a href="/careers" class="elementor-sub-item"
                            tabindex="-1">Careers</a>
                        </li>
                      </ul>
                    </li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-6866">
                      <a href="#" class="elementor-item elementor-item-anchor" tabindex="-1">Services</a>
                      <ul class="sub-menu elementor-nav-menu--dropdown">
                        <li v-for="cat in generalStore.categories" :key="cat.id" class="menu-item menu-item-has-children menu-item-type-post_type menu-item-object-page menu-item-6869">
                          <a :href="`/our-services/category/` + cat.slug" class="elementor-sub-item elementor-item-anchor">
                            {{ cat.name }}
                          </a>
                          <ul class="sub-menu elementor-nav-menu--dropdown">
                            <li v-for="subCat in cat.subCategories" :key="subCat.id" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-6869">
                              <a :href="`/our-services/details/` + cat.slug + `/` + subCat.slug" class="elementor-sub-item">
                                {{ subCat.name }}
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-6866">
                      <a href="#" class="elementor-item elementor-item-anchor" tabindex="-1">Projects</a>
                      <ul class="sub-menu elementor-nav-menu--dropdown">
                        <li class="menu-item menu-item-has-children menu-item-type-post_type menu-item-object-page menu-item-6869">
                          <a href="/projects" class="elementor-sub-item elementor-item-anchor">
                            Ongoing Projects
                          </a>
                        </li>
                        <li class="menu-item menu-item-has-children menu-item-type-post_type menu-item-object-page menu-item-6869">
                          <a href="/project-experiences" class="elementor-sub-item elementor-item-anchor">
                            Our Experiences
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7507">
                      <a href="/news" class="elementor-item" tabindex="-1">News</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </header>
</template>

<script>
  import { onMounted } from 'vue'
  import { useGeneralStore } from '@/stores/generalStore'

  export default {
    name: 'HeaderComponent',
    setup() {
      const generalStore = useGeneralStore()

      onMounted(async () => {
        await generalStore.fetchGeneral()
      })

      return {
        generalStore
      }
    },
  }
</script>
<style>
  .elementor-kit-5 {
    --e-global-color-vamtam_accent_2: #66A89A;
  }
</style>

<style scoped>
  .elementor-2238 .elementor-element.elementor-element-842f9b4 {
    --vamtam-pointer-color-hover: var(--e-global-color-vamtam_accent_2);
    --vamtam-pointer-color-active: var(--e-global-color-vamtam_accent_2);
  }
</style>
